import React from 'react'
import { useDraggable } from '@dnd-kit/core'
import { BaseProps } from './type'
import { CSS } from '@dnd-kit/utilities'

export const Draggable = <T extends React.ElementType>(props: BaseProps<T>) => {
    const {
        as,
        id,
        data,
        style,
        children,
        withinScrollFix,
        ...rest
    } = props
    const Element = as

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        isDragging,
    } = useDraggable({
        id: props.id,
        data: props.data,
    })

    const scrollFixStyle: React.CSSProperties | undefined = transform
        ? {
              // FIXME https://docs.dndkit.com/api-documentation/draggable/drag-overlay
              // If your draggable item is within a scrollable container, we also recommend you use a <DragOverlay>, otherwise you'll need to set the draggable element to position: fixed yourself so the item isn't restricted to the overflow and stacking context of its scroll container, and can move without being affected by the scroll position of its container.
              position: withinScrollFix ? 'fixed' : 'relative',
              opacity: isDragging ? 0.4 : 1,
              transform: CSS.Transform.toString(transform),
          }
        : undefined

    return (
        <Element
            ref={setNodeRef}
            style={{
                ...style,
                ...scrollFixStyle,
            }}
            {...listeners}
            {...attributes}
            {...rest}
        >
            {children}
        </Element>
    )
}
